import React from 'react';

function Login() {
  function handleSubmit(e) {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);
    const jsonData = {};
    for (let [key, value] of data) {
      jsonData[key] = value;
    }

    fetch("/login", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(jsonData),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.isToken) {
          window.location = "/privat";
        } else {
          alert(res.err);
        }
      });
  }

  return (
    <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }} dir="rtl">
      <div className="card p-4 shadow" style={{ maxWidth: '400px', width: '100%' }}>
        <h2 className="text-center mb-4">התחברות</h2>
        <form id="f-login" method="POST" onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">אימייל</label>
            <input type="email" className="form-control" name="email" required />
          </div>

          <div className="mb-3">
            <label htmlFor="password" className="form-label">סיסמה</label>
            <input type="password" className="form-control" name="password" required />
          </div>

          <div className="d-grid gap-2">
            <button type="submit" className="btn btn-primary">כניסה</button>
          </div>
        </form>

        <div className="text-center mt-3">
          <a href="/forget" className="btn btn-link">שכחתי סיסמה</a>
        </div>
        
        <div className="text-center mt-3">
  <a href="/sign" className="btn btn-outline-secondary w-100">
    עדיין אין לך חשבון? להרשמה
  </a>
</div>

      </div>
    </div>
  );
}

export default Login;
